<template>
  <div class="content"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
  <v-breadcrumbs :items="page" class="ml-2 mt-0 pt-0"></v-breadcrumbs>
    <template >
      <v-toolbar flat class="rounded-lg">
        <v-toolbar-title style="margin-left: 20px;"><v-icon class="mx-2">mdi-notebook-outline</v-icon> Topic </v-toolbar-title> 
        <v-spacer></v-spacer>
        <v-flex lg3>
          <v-text-field class="pt-3 mr-4" v-model="search" append-icon="mdi-magnify" label="Search"></v-text-field>
        </v-flex> 
        <!--v-dialog-->
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn 
              outlined
              rounded
              small
              color="primary"
              dark
              class="mb-2" 
              v-bind="attrs"
              v-on="on"
              >
              Tambah aturan kata kunci group baru
              <v-icon class="ml-2">mdi-plus</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title><span class="text-h6">{{ formTitle }}</span></v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field outlined dense v-model="topicname" label="Role Name">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-select dense outlined item-text="active" item-value="value" v-model="topicstatus" :items="itemtopicstatus"></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions class="py-3">
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
                Cancel
              </v-btn>
              <v-btn color="blue darken-1" style="width: 90px;" rounded dark dense @click="save">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDelete" width="330px"> 
          <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
            <v-avatar class="color-avatar3 my-4" size="62">
              <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
            </v-avatar>
            <div class="text-center text-h6 align-center justify-center font-weight-medium">
              Confirm Deletion
            </div> 
            <v-card-text class="align-center justify-center mt-2">
              Are you sure you want to permanently delete this item?
            </v-card-text>

            <v-divider class="mt-4" style=""></v-divider>

            <v-card-actions class="align-center justify-center">
              <v-btn rounded class="my-3 btn-ok" width="90px" dark @click="deleteItemConfirm">
                OK
              </v-btn>
              <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="closeDelete">
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

    <v-data-table
      :headers="headers"
      :items="topic"
      :search="search"
      sort-by="modulename"
      class="table-user ml-6 mr-6 mt-4 rounded-lg"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon class="mx-2" small  @click="editItem(item.SEQ_ID)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item.SEQ_ID)">
            mdi-delete
          </v-icon>
        </template>
        
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
    </v-data-table>
    <Notification  ref="alert"></Notification>
  </div>
</template>

<script>
import axios from "axios"
import Notification from  '@/components/Notification';
  export default {
    components: {
      Notification: Notification
    },
    data: () => ({
    search: '',
    dialog: false,
    dialogDelete: false,
    topicname: '',
    topicstatus: 0,
    itemtopicstatus: [
      {value: 1, active: 'Enabled'},
      {value: 0, active: 'Disabled'}
    ],
    page: [
        {
          text: 'Home',
          disabled: false,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Keyword Manager',
          disabled: false,
          href: 'breadcrumbs_link_1',
        },
        {
          text: 'Topic',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ],
      headers: [
        { text: 'Topic Name', value: 'GROUP_NAME' },
        { text: 'Topic Status', value: 'GROUP_STATUS_TEXT' },
        { text: 'Created Date', value: 'SYS_CREATED_DATE' },
        { text: 'Created By', value: 'SYS_CREATED_BY' },
        { text: 'Update Date', value: 'SYS_UPDATED_DATE' },
        { text: 'Update By', value: 'SYS_UPDATED_BY' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      topic: [],
      id_topic: '',
      editedIndex: -1,
      editedItem: {
        //....
      },
      defaultItem: {
        //....
      },
    }),
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Tambah Kata Kunci' : 'Edit Kata Kunci'
      },
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    created () {
      this.initialize()
    },
    methods: {
      async initialize () {
        axios.get("topic",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            this.topic = response.data
            console.log(response.data);
            // end loading 
            setTimeout(() =>{
              this.loading = false
            },1000)
          })
          .catch((e) => {
              switch (e.response.status) {
                 
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                  }
          this.errors=e.response.data.msg;
        });
      },
      editItem (item) {
        // alert(item);
        this.editedIndex = 1
        this.editedItem = Object.assign({}, item)
        this.dialog = true
        axios({
          method: "put",
          url: "topic_id",
          data: {
            id: item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
            console.log(response.data);
            const dat = response.data;
            // alert(dat.GROUP_STATUS);
            this.id_topic = dat.SEQ_ID;
            this.topicname = dat.GROUP_NAME
            this.topicstatus = dat.GROUP_STATUS
            // this.editedItem = {
            //   groupname:dat.GROUP_NAME,
            //   groupstatus:dat.GROUP_STATUS,
            // }
            setTimeout(() =>{
              this.loading = false
            },1000)
          
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
      },
      deleteItem (item) {      
        this.id_topic = item
        this.editedIndex = this.topic.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
        // alert( this.editedItem);
      },
      deleteItemConfirm () {
        this.topic.splice(this.editedIndex, 1)
        axios({
          method: "delete",
          url: "topic/delete",
          data: {
            seq_id: this.id_topic
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
          // handle success
          console.log(response.data.data);
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        this.closeDelete()
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      save () {
        // edit 
        // alert(this.topicstatus.active);
        console.log(this.topicstatus);
        if (this.editedIndex > -1) {
          // alert(this.topic[this.editedIndex]);
          Object.assign(this.topic[this.editedIndex], this.editedItem)
          axios.put("topic/update", 
            {
              seq_id:this.id_topic,
              group_name:this.topicname,
              status:this.topicstatus,
            },
            
            {headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
            
              this.initialize();
              this.$router.push('/topic');
              // alert('okk');      
              console.log(response.data);  
            })
          .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                    }
            this.errors=e.response.data.msg;
          });
        // insert 
        } else {
          this.topic.push(this.editedItem)
          axios.post("topic/insert", 
            {
              group_name:this.topicname,
              status:this.topicstatus,
            },
            { headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
              this.initialize();
              this.$router.push('/topic');
              console.log(response.data);  
            })
          .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                    }
            this.errors=e.response.data.msg;
          });

        }
        this.close();
      },
    },
  }
</script>

<style scoped>
.btn-ok{
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.v-avatar.color-avatar3
{
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
</style>